/* eslint-disable array-callback-return */
import React from 'react';
import { Box } from "../Box/index.js";
import { isSaudiSymbol } from "../../utils/index.js";
import { TYPOGRAPHY_VARIANT } from "../../theme/typography.theme/index.js";
import { Typography } from "../Typography/index.js";
import { COLOR_VARIANTS } from "../../theme/palette.theme/index.js";
import { ThemeSingleton } from "../../theme/index.js";
export var CurrencySymbol = function CurrencySymbol(_ref) {
  var currency = _ref.currency,
    children = _ref.children,
    variant = _ref.variant,
    color = _ref.color,
    className = _ref.className;
  // eslint-disable-next-line prefer-destructuring
  var themeDirection = ThemeSingleton.getInstance('ltr').direction;
  var displayCurrency = isSaudiSymbol(currency) ? /*#__PURE__*/React.createElement(Box, {
    component: "span",
    sx: {
      fontFamily: 'Claudion !important',
      fontWeight: 'normal !important'
    }
  }, "\u20C0") : currency;
  return children && variant ? /*#__PURE__*/React.createElement("div", {
    style: {
      direction: isSaudiSymbol(currency || '') ? 'ltr' : themeDirection
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: variant || TYPOGRAPHY_VARIANT.BODY1,
    component: "span",
    color: color || COLOR_VARIANTS.MINESHAFT
  }, displayCurrency, ' ', /*#__PURE__*/React.createElement("span", {
    style: {
      direction: 'ltr',
      unicodeBidi: 'bidi-override'
    }
  }, children))) : /*#__PURE__*/React.createElement(Box, {
    className: className,
    component: "span"
  }, displayCurrency);
};